<script>
import { Doughnut } from 'vue-chartjs';
import { merge } from 'lodash';

export default {
  name: 'Data-Pie',
  extends: Doughnut,
  props: {
    chartData: {
      required: true,
    },
    colours: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },
    enableCentreTotal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true, // <-- set this
            // a callback that will handle
            generateLabels(chart) {
              const { data } = chart;

              if (data.labels.length && data.datasets.length) {
                const dataset = data.datasets[0];
                return data.labels.map((label, index) => {
                  const text = dataset.data[index];
                  const fillStyle = dataset.backgroundColor[index];

                  const meta = chart.getDatasetMeta(0);

                  return {
                    text,
                    fillStyle,
                    hidden: meta.data[index].hidden,
                    lineWidth: 1,
                    index,
                  };
                });
              }
              return [];
            },
          },
        },
        onClick: (e, item) => {
          this.$emit('click', { item: item[0], chartData: this.chartData });
        },
        hover: {},
        tooltips: {
          bodyFontStyle: 'bold',
        },
        defaultFontColor: '#34668C',
      }
    }
  },
  mounted() {
    this.render();
    if (this.enableCentreTotal) {
      this.renderCentralText(1000);
    }
  },
  methods: {
    render() {
      if (!this.chartData.series) {
        return false;
      }

      const { series } = this.chartData;

      const labels = series.data.map(row => row.name);
      const shortLabels = series.data.map(row => row.label);
      const colourMap = series.data.map(row => this.colours[row.label]);
      const values = series.data.map(row => row.count);

      const legend = [];

      labels.forEach((name, index) => {
        legend[index] = {
          name: name,
          label: shortLabels[index],
        };
      });

      this.$emit('set-legend', legend);
      
      const options = merge(this.defaultOptions, this.options);

      const datasets = [
        {
          data: values,
          backgroundColor: colourMap,
          hoverBackgroundColor: colourMap,
        },
      ];

      const dataCollection = {
        labels,
        datasets,
      };
      
      this.renderChart(dataCollection, options);
    },
    renderCentralText(val) {
      function updateText(chart) {
        const { legend, data, options } = chart;
        const { ctx } = chart.chart;
        let width;
        let height;
        const chartData = data.datasets[0].data;

        switch (legend.position) {
          case 'left':
            width = legend.right;
            height = chart.chart.height;
            break;

          case 'right':
            width = legend.left;
            height = chart.chart.height;
            break;

          case 'top':
            width = chart.chart.width;
            height = legend.bottom;
            break;

          case 'bottom':
            width = chart.chart.width;
            height = legend.top;
            break;

          default:
            width = chart.chart.width;
            height = chart.chart.height;
        }

        ctx.restore();
        const fontReference = (width < height) ? width : height;
        const fontSize = (fontReference / 114).toFixed(2);
        ctx.font = fontSize + "em " + options.defaultFontFamily;
        ctx.textBaseline = "middle";
        ctx.fillStyle = options.defaultFontColor;

        const total = chartData.reduce((a, b) => a + b, 0);
        const reductions = legend.legendItems.filter(item => item.hidden === true).reduce((a, b) => a + b.text, 0);
        const text = total - reductions;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();
      }
      
      Chart.pluginService.register({
        beforeDraw: function(chart) {
          updateText(chart);
        },
        afterDatasetUpdate: function(chart) {
          updateText(chart);
        }
      });
      
    }
  },
};
</script>
